var app = angular.module("leonardo");

var PropertyDeletedFilters = function (
  $scope,
  $controller
) {

  $controller('FiltersBaseController', { $scope: $scope });

  var filters = $scope.filterService.hasFilter('filters') ? $scope.filterService.getFilter('filters') : [];


  if (!_.contains(filters,'search')) {
    filters.push('search');
  }

  $scope.filterService.setFilter('filters', filters);

  $scope.filters_options = [
    {
      group: 'hierarchy',
      name: 'By Hierarchy',
      elements: [
        {
          id: 'account_reports',
          name: 'Account',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          placeholder: 'All Accounts',
          condition: $scope.filterService.accounts.length > 1,
          options: $scope.filterService.accounts,
          conflicts: ['property_reports', 'portfolio_reports', 'group_reports', 'managed_by_reports']
        },
        {
          id: 'group_reports',
          name: 'Property Group',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          placeholder: 'All Groups',
          condition: $scope.filterService.groups.length > 1 && !$scope.only_account,
          options: $scope.filterService.groups,
          conflicts: ['property_reports', 'portfolio_reports', 'managed_by_reports', 'account_reports']
        },
        {
          id: 'portfolio_reports',
          name: 'Portfolio',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          placeholder: 'All Portfolios',
          condition: $scope.filterService.portfolios.length > 1 && !$scope.only_account,
          options: $scope.filterService.portfolios,
          conflicts: ['property_reports', 'group_reports', 'managed_by_reports', 'account_reports']
        }
      ]
    },
    {
      id: 'search',
      name: 'Property Name',
      label: null,
      inline: false,
      type: 'text',
      placeholder: 'Property Name',
      condition: true,
      conflicts: [],
      onSubmit: $scope.filter
    }
  ];

};

app.controller('PropertyDeletedFilters', [
  '$scope',
  '$controller',
  PropertyDeletedFilters
]);
